import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { Run } from '../model/run.model';

@Injectable({ providedIn: 'root' })
export class RunService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    create(run: Run): Observable<Run | null> {
        return this._http.post<Run | null>(
            `${this._appConfig.API_ENDPOINTS.REPORT}/runs`,
            run,
        );
    }

    retrieve(runId: string): Observable<Run | null> {
        return this._http
            .get<Run | null>(
                `${this._appConfig.API_ENDPOINTS.REPORT}/runs/${runId}`,
            )
            .pipe(
                tap((ret) => {
                    ret?.results?.forEach((r) => {
                        if (r.timestamp != null) {
                            r.timestamp = new Date(r.timestamp);
                        }
                    });
                }),
            );
    }
}
